<template>
  <div>
    <el-card class="box-card">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>高级功能</el-breadcrumb-item>
        <el-breadcrumb-item>远程变量</el-breadcrumb-item>
      </el-breadcrumb>
    </el-card>

    <el-card class="content">
      <div class="navbtn">
        <el-card class="button-content">
        <el-button type="primary" size="small" icon="el-icon-refresh" circle @click="refresh" :loading="state"></el-button>
        <el-button type="primary" size="small" icon="el-icon-plus" @click="addAgentBtn" :loading="state">添加远程变量</el-button>
        </el-card>
      </div>

      <el-form :inline="true" :model="addAgentForm" class="demo-form-inline" ref="agentRef" size="small" style="margin:20px 0">
        <el-form-item label="软件 " prop="softName" >
          <el-select v-model="queryInfo.softName" placeholder="全部软件" clearable @change="changeInput()">
            <el-option v-for="item in allSoftName" :key="item" :label="item" :value="item"></el-option>
          </el-select>
        </el-form-item>

        <el-button type="primary" size="small" @click="query" :loading="state" icon="el-icon-search">查 询</el-button>
        <el-button size="small" @click="reSet" :loading="state" icon="el-icon-refresh-left">重 置</el-button>
      </el-form>
      <el-tag size="small" type="danger" style="margin-bottom:5px;color:red">*为防止滥用远程数据，变量，每个用户每月有50万次免费额度，超过的按 50万次/1元/月 计费，不足50万次的按50万次计算。</el-tag>
      <el-table :data="tableList" border style="width: 100%" stripe v-loading="loading">
        <el-table-column prop="softName" label="所属软件" width="200"></el-table-column>
        <el-table-column prop="varName" label="变量名" width="170"></el-table-column>
        <el-table-column prop="varValue" label="变量值" width="170"></el-table-column>
        <el-table-column prop="remarks" label="备注"></el-table-column>
        <el-table-column prop="createDate" label="创建时间" width="170"></el-table-column>
        <el-table-column prop="updateDate" label="修改时间" width="170"></el-table-column>
        <el-table-column label="操作" width="150">
          <template slot-scope="scope">
            <el-button type="primary" size="mini" @click="integral(scope.row)">编 辑</el-button>
            <el-button @click="unbinding(scope.row)" size="mini" type="danger">删 除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="queryInfo.pagenum"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="queryInfo.pagesize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </el-card>

    <!-- 新建远程变量 -->
    <el-dialog title="新建远程变量" :close-on-click-modal="false" :visible.sync="addDialogVisible" :width="addAgentWidth" @close="closeAddDiaLog">
      
      <el-form :model="addAgentForm" :rules="addAgentrules" ref="addAgentFormRef" label-width="80px" class="demo-ruleForm" size="small">
        <el-form-item label="所属软件" prop="softName">
          <el-select v-model="addAgentForm.softName" placeholder="请选择软件" clearable @change="changeInput()">
            <el-option v-for="item in allSoftName" :key="item" :label="item" :value="item"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="变量名" prop="varName" >
          <el-input v-model="addAgentForm.varName" clearable placeholder="长度不超过64个字符"></el-input>
        </el-form-item>

        <el-form-item label="变量值" prop="varValue">
          <el-input type="textarea" v-model="addAgentForm.varValue" placeholder="长度不超过256个字符" :autosize="{ minRows: 1, maxRows: 4}"></el-input>
        </el-form-item>

        <el-form-item label="备注" prop="remarks">
          <el-input type="textarea" v-model="addAgentForm.remarks" placeholder="长度不超过128个字符"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" size="small" @click="createRemoteVar" :loading="state">创 建</el-button>
      </span>
    </el-dialog>

    <!-- 编辑远程变量Dialog -->
    <el-dialog title="编辑远程变量" :close-on-click-modal="false" :visible.sync="integralDialogVisible" :width="addSubWidth" >
      <el-form :model="editRemoteVarForm" :rules="editRemoteVarrules" ref="editRemoteVarRef" label-width="110px" class="demo-ruleForm" size="small">
        <el-form-item label="所属软件" prop="softName">
          <el-select v-model="editRemoteVarForm.softName" placeholder="请选择软件" clearable @change="changeInput()">
            <el-option v-for="item in allSoftName" :key="item" :label="item" :value="item"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="变量名" prop="varName" >
          <el-input v-model="editRemoteVarForm.varName" clearable placeholder="长度不超过64个字符"></el-input>
        </el-form-item>

        <el-form-item label="变量值" prop="varValue">
          <el-input type="textarea" v-model="editRemoteVarForm.varValue" placeholder="长度不超过256个字符" :autosize="{ minRows: 1, maxRows: 4}"></el-input>
        </el-form-item>

        <el-form-item label="备注" prop="remarks">
          <el-input type="textarea" v-model="editRemoteVarForm.remarks" placeholder="长度不超过128个字符"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" size="small" @click="integralBtn">保 存</el-button>
      </span>
    </el-dialog>



    <!-- 删除此远程变量dialog -->
    <el-dialog title="确定要删除此远程变量" :close-on-click-modal="false" :visible.sync="unbindingDialog" :width="agentRightWidth">
      <div slot="title" class="header-title">
        <span class="title-name" style="font-size:20px"><i class="el-icon-warning" style="color: #e6a23c;margin-right:10px"></i>确定要删除此远程变量</span>
      </div>

      <span style="margin-left:30px">{{editRemoteVarForm.varName}}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="unbindingDialog = false" size="small">取 消</el-button>
        <el-button type="danger" @click="unbindingDialogBtn" size="small" :loading="state">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data(){
    return{
      addDialogVisible: false,
      addAgentForm:{},
      editRemoteVarForm:{},
      addAgentrules:{
        softName: [
          { required: true, message: "请选择软件!", trigger: ["blur", "change"] },
        ],
        varName: [
          { required: true, message: "请填写变量名!", trigger: ["blur", "change"] },
          { min: 0,max: 64,message: "不能超过64个字符!",trigger: ["blur", "change"]},
        ],
        varValue: [
          { required: true, message: "请填写变量值!", trigger: ["blur", "change"] },
          { min: 0,max: 256,message: "不能超过256个字符!",trigger: ["blur", "change"]},
        ],
        remarks: [
          { min: 0,max: 128,message: "不能超过128个字符!",trigger: ["blur", "change"]},
        ]
      },
      editRemoteVarrules:{
        softName: [
          { required: true, message: "请选择软件!", trigger: ["blur", "change"] },
        ],
        varName: [
          { required: true, message: "请填写变量名!", trigger: ["blur", "change"] },
          { min: 0,max: 64,message: "不能超过64个字符!",trigger: ["blur", "change"]},
        ],
        varValue: [
          { required: true, message: "请填写变量值!", trigger: ["blur", "change"] },
          { min: 0,max: 256,message: "不能超过256个字符!",trigger: ["blur", "change"]},
        ],
        remarks: [
          { min: 0,max: 128,message: "不能超过128个字符!",trigger: ["blur", "change"]},
        ]
      },
      state:false,
      allSoftName:"",

      tableList:[],
      queryInfo: {
        query: "",
        //当前的页数
        pagenum: 1,
        //当前每页显示多少条数据
        pagesize: 10,
        email: this.$store.state.account,
      },
      total:0,
      integralDialogVisible:false,

      integralForm:{
        action:"购买",
        integral:0
      },
      integralFormrules:{
        action:[
          { required: true, message: "请选择!", trigger: ["blur", "change"] }
        ],
        
      },
      integralInfo:"",
      rightDialogVisible:false,
      upperLimit:false,
      unbindingDialog:false,
      loading:true,
      addAgentWidth:'500px',
      addSubWidth:'500px',
      agentRightWidth:'500px'
    }
  },
  created(){
    this.getCardTypeSoftName()
    this.getRemoteVarList()
    if (document.body.clientWidth < 700){
      this.addAgentWidth = '100%'
      this.addSubWidth = '100%'
      this.agentRightWidth = '100%'
    }
  },
  methods:{
    //得到远程变量
    async getRemoteVarList(){
      //const result = await this.$http.get(`getRemoteVarList?email=${this.$store.state.account}`);
      console.log(this.queryInfo);
      this.state = true
      const result = await this.$http.get("remoteVarList",{
        params:this.queryInfo
      });
      this.state = false;
      console.log('远程变量result',result);
      if(result.data.meta.status == 200){
        if (result.data.data.total > 0) {
          this.tableList = result.data.data.result.map(ele =>{
            ele.createDate = this.$moment(ele.createDate).format('YYYY-MM-DD HH:mm:ss')
            ele.updateDate = this.$moment(ele.updateDate).format('YYYY-MM-DD HH:mm:ss')
            return ele
          })
          this.total = result.data.data.total
        }else{
          this.total = 0
          this.tableList = []
        }
      }else{
        this.total = 0
        this.tableList = []
      }
      this.loading = false
    },
    async getCardTypeSoftName(){
      this.state = true
      const result = await this.$http.post("cardGetSoft", {email:this.$store.state.account});
      this.state = false
      //console.log(result);
      this.allSoftName = result.data.data.result.map(element => {
        return element.softName
      })
    },
    addAgentBtn(){
      this.addDialogVisible = true
    },
    refresh(){

    },
    closeAddDiaLog(){
      console.log('关闭了');
      this.$refs.addAgentFormRef.resetFields()
    },
    //创建远程变量
    async createRemoteVar(){
      this.$refs.addAgentFormRef.validate(async valid => {
        if(!valid) return
        this.state = true
        this.addAgentForm.email = this.$store.state.account
        const result = await this.$http.post("createRemoteVar", this.addAgentForm);
        this.state = false
        if(result.data.meta.status !== 200){
          this.$notify.error({title: '错误',message:result.data.meta.msg});
          return
        }
        this.$notify({title: '成功',message: result.data.meta.msg, type: 'success'});
        this.addDialogVisible = false
        this.$refs.addAgentFormRef.resetFields()
        this.getRemoteVarList()
      })
    },
    refresh(){
      this.getCardTypeSoftName()
      this.getRemoteVarList()
    },
    query(){
      this.queryInfo.pagenum = 1
      this.getRemoteVarList()
    },
    reSet(){
      this.queryInfo.softName = ""
      this.queryInfo.agentEmail = ""
      this.$refs.agentRef.resetFields()
      this.getRemoteVarList()
    },
    handleSizeChange(val) {
      //console.log(`每页 ${val} 条`);
      this.queryInfo.pagesize = val
      this.getRemoteVarList()
    },
    // 监听 页码值 改变的事件
    handleCurrentChange(val) {
      //console.log(`当前页: ${val}`);
      this.queryInfo.pagenum = val
      this.getRemoteVarList()
    },
    //加减积分
    integral(index){
      this.integralDialogVisible = true
      this.editRemoteVarForm = JSON.stringify(index)
      this.editRemoteVarForm = JSON.parse(this.editRemoteVarForm)
      //console.log(this.editRemoteVarForm);
    },
    integralBtn(){
      this.$refs.editRemoteVarRef.validate(async valid => {
        console.log(valid);
        console.log(this.editRemoteVarForm);
        if(!valid) return
        this.state = true
        this.editRemoteVarForm.email = this.$store.state.account
 
        const result = await this.$http.post("updateRemoteVar", this.editRemoteVarForm);
        this.state = false
        console.log('result=>',result);
        if(result.data.meta.status !== 200){
          this.$notify.error({title: '错误',message:result.data.meta.msg});
          return
        }
        this.$notify({title: '成功',message: result.data.meta.msg, type: 'success'});
        this.integralDialogVisible = false
        this.$refs.editRemoteVarRef.resetFields()
        this.getRemoteVarList()
      })
    },

    async rightBtn(){
      this.state = true
      this.integralInfo.isUpperLimit = this.upperLimit
      this.integralInfo.email = this.$store.state.account
      const result = await this.$http.post("isUpperLimit", this.integralInfo);
      this.state = false
      if(result.data.meta.status !== 200){
        this.$notify.error({title: '错误',message:result.data.meta.msg});
        return
      }
      this.$notify({title: '成功',message: result.data.meta.msg, type: 'success'});
      this.rightDialogVisible = false
      this.getRemoteVarList()
    },
    unbinding(index){
      this.editRemoteVarForm = index
      this.unbindingDialog = true
    },
    async unbindingDialogBtn(){
      this.state = true
      this.editRemoteVarForm.email = this.$store.state.account
      const result = await this.$http.post("delRemoteVar", this.editRemoteVarForm);
      this.state = false
      if(result.data.meta.status !== 200){
        this.$notify.error({title: '错误',message:result.data.meta.msg});
        return
      }
      this.$notify({title: '成功',message: result.data.meta.msg, type: 'success'});
      this.unbindingDialog = false
      this.getRemoteVarList()
    },
    changeInput(e){
      this.$forceUpdate()
    }
  }
}
</script>

<style lang="less" scoped>
.content {
  margin: 5px;
  .el-pagination {
    margin-top: 20px;
    display: flex;
    justify-content: flex-end;
    flex-wrap: wrap;
  }
}
.custom{
  display: flex;
  justify-content: flex-start;
  .el-switch{
    margin-left: 10px;
  }
}
</style>